/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
/*
 * @Author: Nora Galvin
 * @Date: 2020-08-21 08:51:35
 * @Last Modified by: Nora
 * @Last Modified time: 2020-08-24 11:02:14
 */
import template from './template.html';

/**
 * CheckboxCBntrol
 */
export default class CheckBoxControl {
  _$input: JQuery;
  _options: any;

  /**
   * constructor
   * @param $input ..
   * @param options ..
   */
  constructor($input: JQuery, options?: any) {
    this._$input = $input;
    this._options = options;
    this.renderTemplate();
  }

  /**
   * Render Checkbox to Template
   * @returns void
   */
  renderTemplate(): void {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const _this = this;
    this._$input.hide();
    const html = template();

    this._$input.off('change').on('change', function () {
      const name = _this._$input.attr('name') || '';
      const value = _this._$input.is(':checked');

      const data = {
        name: name,
        value: value,
      };
      if (_this._options && _this._options.onChange) {
        _this._options.onChange(data);
      }
    });

    const $html = $(html);

    this._$input.after($html);
  }

  /**
   * Set value to select
   * @param val ..
   * @returns void
   */
  setValue(val: string | number): void {
    this._$input.val(val);
  }
}
